import type { AlertBannerCardProps } from '../../../types/alerts.d';

import React, { useState } from 'react';
import {
	faArrowRight,
	faArrowsMaximize,
	faMapMarker,
} from '@fortawesome/pro-light-svg-icons';

import { Div } from '/react4xp/components/Element';
import { FontAwesomeIconWrapper } from '/react4xp/components/FontAwesomeIconWrapper';
import { Lightbox } from '/react4xp/shared/Lightbox/Lightbox';

import { AlertBannerLabel } from '../AlertBannerLabel/AlertBannerLabel';
import { IconWithText } from '../IconWithText/IconWithText';

import { openLightboxWithKeys } from './openLightboxWithKeys';
import { DateComponent } from './DateComponent';
import { HEADER } from './constants';
import { getAlertBannerType } from './getAlertBannerType';


export function AlertBannerCardLink({
	alertListLink,
	date,
	id,
	image,
	location,
	title,
	alertType,
}: Pick<AlertBannerCardProps,
	'alertListLink' | 'date' | 'id' | 'image' | 'location' | 'title' | 'alertType'
>): React.JSX.Element {
	const [lightboxImage, setLightboxImage] = useState<string | null>(null);
	return (
		<div
			className='alert-banner-card'
			id={id}
		>
			<Div
				className={[
					'alert-banner-card__header',
					HEADER.NORMAL,
					getAlertBannerType(alertType, date.isExpired),
				]}
			>
				{image &&
					<figure className="lightbox-image lightbox-image__header-wrapper"
						onClick={() => setLightboxImage(image.url)}
						onKeyDown={(e) => openLightboxWithKeys(e, () => setLightboxImage(image.url))}
						tabIndex={0}
						role="button"
						aria-label="Åpne bildevisning"
					>
						<img
							className="lightbox-image__header-wrapper__image"
							draggable={false}
							loading="eager"
							src={image.url} alt="Bilde av stoff"
						/>
						<span className="lightbox-image__header-wrapper__icon">
							<FontAwesomeIconWrapper
								className='text-white'
								fixedWidth={true}
								icon={faArrowsMaximize}
							/>
						</span>
					</figure>}
				<a
					className='alert-banner-card__header__container'
					href={alertListLink}
				>
					<div className='alert-banner-card__header__content'>
						<AlertBannerLabel alertType={alertType} />
						{title && <h2 className="text-balance">{title}</h2>}
						<DateComponent date={date}/>
						{location && <IconWithText icon={faMapMarker} text={location}/>}
					</div>
					<FontAwesomeIconWrapper
						className="alert-banner-card__header__icon link"
						fixedWidth={true}
						icon={faArrowRight}
					/>
				</a>
			</Div>
			<Lightbox image={lightboxImage} onClose={() => setLightboxImage(null)} />
		</div>
	);
}
